import { Initializer } from 'common/types/initializers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';
import type { RequirePrepaymentModalProps } from 'reconnect-types/moduleFederation';

export const RequirePrepaymentModalInitializer = ({
  appointmentId,
  bookingActor,
  customerId,
  isPaymentProtected,
  isPrepaid,
  onClose,
  onConfirm,
}: RequirePrepaymentModalProps): Initializer => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const destroy = () => {
    ReactDOM.unmountComponentAtNode(container);
    container.remove();
  };

  const render = () => {
    ReactDOM.render(
      <Reconnect
        name="RequirePrepaymentModal"
        props={{
          appointmentId,
          bookingActor,
          customerId,
          isPaymentProtected,
          isPrepaid,
          onClose: () => {
            onClose?.();
            destroy();
          },
          onConfirm: () => {
            onConfirm?.();
            destroy();
          },
        }}
      />,
      container,
    );
  };

  return { destroy, render };
};
